import { Redirect } from "react-router-dom";
import { message } from "antd";
import React, { useEffect, useState } from "react";

export const DelayedRedirect = ({ to, delay = 5, children, warning }) => {
	const [redirectionEnabled, setRedirection] = useState(false);

	useEffect(() => {
		warning && message.warning(warning);
		setTimeout(() => setRedirection(true), delay);
	}, []);

	if (!redirectionEnabled && !!children) return children;
	return <Redirect to={to} />;
};
